var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pp-container',{class:{'is-slide-right': _vm.slide}},[_c('pp-slide-aside',[_vm._t("slide")],2),_c('pp-container',{nativeOn:{"click":function($event){return _vm.handleContentClick.apply(null, arguments)},"touchmove":function($event){return _vm.move.apply(null, arguments)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }